import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const SolucionesEmpresas = lazy(() => import("../pages/soluciones-empresas/page"));
const Catalogo = lazy(() => import("../pages/catalogo/page"));
const ComoTrabajamos = lazy(() => import("../pages/como-trabajamos/page"));
const Nosotros = lazy(() => import("../pages/nosotros/page"));
const Blog = lazy(() => import("../pages/blog/page"));
const Contacto = lazy(() => import("../pages/contacto/page"));
const AvisoPrivacidad = lazy(() => import("../pages/aviso-privacidad/page"));
const BlogPost1 = lazy(() => import("../pages/blog/donde-comprar-articulos-oficina-puebla/page"));
const BlogPost2 = lazy(() => import("../pages/blog/como-optimizar-compras-papeleria-empresa/page"));
const BlogPost3 = lazy(() => import("../pages/blog/insumos-oficina-empresa-mediana/page"));
const BlogPost4 = lazy(() => import("../pages/blog/ventajas-proveedor-b2b-insumos-puebla/page"));
const BlogPost5 = lazy(() => import("../pages/blog/reducir-costos-insumos-oficina-calidad/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/soluciones-empresas",
    element: <SolucionesEmpresas />,
  },
  {
    path: "/catalogo",
    element: <Catalogo />,
  },
  {
    path: "/como-trabajamos",
    element: <ComoTrabajamos />,
  },
  {
    path: "/nosotros",
    element: <Nosotros />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "/aviso-privacidad",
    element: <AvisoPrivacidad />,
  },
  {
    path: "/blog/donde-comprar-articulos-oficina-puebla",
    element: <BlogPost1 />,
  },
  {
    path: "/blog/como-optimizar-compras-papeleria-empresa",
    element: <BlogPost2 />,
  },
  {
    path: "/blog/insumos-oficina-empresa-mediana",
    element: <BlogPost3 />,
  },
  {
    path: "/blog/ventajas-proveedor-b2b-insumos-puebla",
    element: <BlogPost4 />,
  },
  {
    path: "/blog/reducir-costos-insumos-oficina-calidad",
    element: <BlogPost5 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;